import { apiRequest } from '../../ConversationPage/apis/client';

import {
  DatevAccountNumber,
  CreateDatevAccountNumberRequest,
  UpdateDatevAccountNumberRequest,
} from './types';

// Get the Datev account number for authenticated user
export const getDatevAccountNumber = async (
  token: string
): Promise<DatevAccountNumber | null> => {
  return apiRequest<DatevAccountNumber | null>({
    endpoint: '/datev/account-numbers',
    method: 'GET',
    token,
  });
};

// Create a new Datev account number
export const createDatevAccountNumber = async (
  data: CreateDatevAccountNumberRequest,
  token: string
): Promise<DatevAccountNumber> => {
  return apiRequest<DatevAccountNumber>({
    endpoint: '/datev/account-numbers',
    method: 'POST',
    body: data,
    token,
  });
};

// Update an existing Datev account number by ID
export const updateDatevAccountNumber = async (
  id: string,
  data: UpdateDatevAccountNumberRequest,
  token: string
): Promise<DatevAccountNumber> => {
  return apiRequest<DatevAccountNumber>({
    endpoint: `/datev/account-numbers/${id}`,
    method: 'PATCH',
    body: data,
    token,
  });
};

// Delete a Datev account number by ID
export const deleteDatevAccountNumber = async (
  id: string,
  token: string
): Promise<{ message: string }> => {
  return apiRequest<{ message: string }>({
    endpoint: `/datev/account-numbers/${id}`,
    method: 'DELETE',
    token,
  });
};
